import classNames from 'classnames';
import AudioPlayer from 'components/AudioPlayer';
import { useTranslation } from 'services/hooks';
import './style.css';

const Question = ({
	id,
	title,
	answers,
	answerStatus,
	onAnswer,
	disabled,
	questionNumberInTest,
	questionImageLink = '',
	questionAudioLink = '',
	questionInstruction = null,
	questionParagraph = null,
}) => {
	const questionClassName = classNames('Question', { [answerStatus]: answerStatus });
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'quiz';

	const _renderAnswers = ({ answerText, answerId, questionId, checked }) => {
		return (
			<CheckBox
				key={answerText}
				questionId={questionId}
				answerDescription={answerText}
				answerStatus={answerStatus}
				answerId={answerId}
				onAnswer={onAnswer}
				checked={checked}
				disabled={disabled}
			/>
		);
	};

	return (
		<div className={questionClassName} question-number={id}>
			<div className="Question__title">
				{questionInstruction && <div className="Question__instruction" dangerouslySetInnerHTML={{ __html: questionInstruction }}></div>}
				{questionParagraph && <div className="Question__paragraph" dangerouslySetInnerHTML={{ __html: questionParagraph }} />}
				<b>{`${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_question_title`)} #${questionNumberInTest}:`} </b>
				<div dangerouslySetInnerHTML={{ __html: title }}></div>
				{questionImageLink && (
					<div className="test_wrapper__image_container">
						<img
							src={questionImageLink}
							className="test_wrapper__image"
							style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'scale-down' }}
						/>
					</div>
				)}
				{questionAudioLink && (
					<div className="test_wrapper__audio">
						<AudioPlayer src={questionAudioLink} />
					</div>
				)}
			</div>
			{answers && answers.map(_renderAnswers)}
		</div>
	);
};

export default Question;

const CheckBox = ({ questionId, answerDescription, answerStatus, answerId, checked, onAnswer, disabled }) => {
	const labelClassName = classNames('CheckBox__input_title', { [`CheckBox__input_title--${answerStatus}`]: answerStatus });

	return (
		<div className="CheckBox__input">
			<input disabled={disabled} type="radio" name={`question${questionId}`} id={`answer_${answerId}`} value={answerId} checked={checked} />
			<label
				htmlFor={`answer_${answerId}`}
				className={labelClassName}
				onClick={e => {
					if (!disabled) onAnswer({ questionId, answerId });
				}}
			>
				{answerDescription}
			</label>
		</div>
	);
};
